module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "StatusChangePanel"
    }
  }, [_c('h1', [_vm._v("ステータスの変更")]), _vm._v(" "), _c('label', {
    staticClass: "cate2"
  }, [_vm._v("新しいステータス:\n    "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.new_status),
      expression: "new_status"
    }],
    staticClass: "statusSelect",
    attrs: {
      "name": "userstatus"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.new_status = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    attrs: {
      "value": "normal",
      "selected": ""
    }
  }, [_vm._v("通常")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "temporal"
    }
  }, [_vm._v("短期（単一）")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "trial"
    }
  }, [_vm._v("体験")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "temp/temp"
    }
  }, [_vm._v("短期（複数、元体験生）")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "temp/norm"
    }
  }, [_vm._v("短期及び長期")])])]), _vm._v(" "), _c('button', {
    staticClass: "square_btn",
    on: {
      "click": _vm.changeStatusLocal
    }
  }, [_vm._v("ステータスを変更")])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-66c74814"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/UserInfo/StatusChangePanel.vue
// module id = 722
// module chunks = 0